export default __webpack_public_path__ + "static/media/icon-battle-large.4b99fb86.svg";